export default {"src":"/_next/static/media/compute.1501e6c9.svg","height":86,"width":86};